import React, { useEffect, useState } from "react";
import "./util.css";
import { useGetStatsMutation } from "../../api/api";
import { DeviceIcon, TagIcon, UsersIcon, CompanyIcon, ProductIcon, ProductCategoriesIcon, SupplierIcon, RoleIcon, ReportIcon, CheckpointTypeIcon, WorkFlowIcon, SpeakerIcon, CameraAltIcon, RFIDIcon, BillBoardIcon } from "../../services/icons";
import { useGetDeviceStatsQuery, useGetUsersStatsQuery, useGetVMSStatsQuery } from "../../api/api";
import { useFactoryDashboardDataMutation } from "../../api/vmsSlice";
import { useThemeSetting } from "../../services/hooks";
import { useSocketContext } from "../../context/socketContext";
import { usePlantContext } from "../../context/plantContext";

export default function Genericstats({ onhandleFilter, checkpointID, filterType = "", isRecallStats, isFactoryStats = false }) {
	const { plantId } = usePlantContext();
	const [statData, setStatData] = useState([]);
	const [isFactoryStatsState, setIsFactoryStatsState] = useState(false);
	const {
		socketData: { checkpointEvents },
	} = useSocketContext();
	const { orgDetail } = useThemeSetting();

	const [getStatsTrigger] = useGetStatsMutation();
	const [getFactoryDashboardData] = useFactoryDashboardDataMutation();
	

	useEffect(() => {
		// filterType comes through checkpoint component
		// checkpointID "all" comes through dashboard
		// when request is through checkpoint, we need to wait for filterType to have a value before making the API call
		let intervalId;
		const fetchStats = async () => {
			if (checkpointID != "all" && !filterType) return;

			const dailyStats = typeof checkpointID === "string" ? getStatsTrigger({ typesArr: ["All"], checkpointId: checkpointID, type: filterType,isCount: true,}).unwrap() : Promise.resolve(null);
			const factoryStats = isFactoryStats ? getFactoryDashboardData({ plantId, checkpointId: checkpointID }).unwrap() : Promise.resolve(null);
			const UpdatedStats = [];
			const [dailyStatsResult, factoryStatsResult]  = await Promise.all([dailyStats, factoryStats]);
			if (dailyStatsResult && !dailyStatsResult?.error) {
				const result = Object.keys(dailyStatsResult.data).map((key) => ({
                    statName: capitalizeWords(key),
                    statValue:
                        typeof dailyStatsResult.data[key] !== "object"
                            ? dailyStatsResult.data[key]
                            : 0,
                }));
				UpdatedStats.push(...result);
			}
			if (factoryStatsResult && !factoryStatsResult?.error) {
				// console.log("factoryData", factoryStatsResult.data[0].count);
				const stats = factoryStatsResult.data[0].count;
				const result = Object.keys(stats).map((key) => ({
					statName: capitalizeWords(key),
					statValue: typeof stats[key] !== "object" ? stats[key] : 0,
				}));
				UpdatedStats.push(...result);
				setIsFactoryStatsState(true)
			}
			setStatData(UpdatedStats);
		};
		fetchStats();
		// Set up polling only when isRecallStats is true
		if (isRecallStats) {
			intervalId = setInterval(fetchStats, 90000);
		}
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [checkpointID, checkpointEvents, filterType, isRecallStats]);

	useEffect(() => {
		// Check if checkpointID is an array and has elements
		if (Array.isArray(checkpointID) && checkpointID.length > 0) {
			// Create an array to hold promises for each API call
			const promises = checkpointID.map(async (ele, index) => {
				try {
					// Fetch stats data for each checkpointID
					const res = await getStatsTrigger({
						typesArr: ["All"],
						checkpointId: ele,
						isCount: true,
					}).unwrap();
					// If response is successful
					if (!res?.error) {
						const UpdatedStats = Object.keys(res?.data).map((key) => ({
							statName: capitalizeWords(key),
							statValue: typeof res?.data[key] !== "object" ? res?.data[key] : 0,
						}));
						// Return different slices of UpdatedStats based on index
						if (index === 0) {
							return UpdatedStats.slice(0, 2);
						} else {
							return UpdatedStats.slice(2, 3);
						}
					}
				} catch (err) {
					console.error(err);
					return null; // Return null for failed promises
				}
			});
			// Resolve all promises
			Promise.all(promises)
				.then((result) => {
					// Flatten the array of arrays
					const flatResult = result.flat();
					// Filter out null values
					const filteredResult = flatResult.filter((item) => item !== null);
					// Set the state with the filtered result
					setStatData(filteredResult);
				})
				.catch((err) => {
					console.error(err);
				});
		}
	}, [checkpointEvents]);
	return (
		<>
			<div className="genericStats-containter" style={isFactoryStatsState ? {flexWrap: 'wrap', gap : '0px 0px'} : {}}>
				{statData.length > 0 &&
					statData.map((ele, index) => {
						return (
							<div className="genericStats-tab" style={isFactoryStatsState ? {maxWidth: '180px', transform: 'scale(0.8)', marginLeft: '-20px'} : {}} key={ele.statName} onClick={(ele) => (onhandleFilter ? onhandleFilter(ele) : "")}>
								<div style={{ color: "#48494a", display : "flex", alignItems: "center", marginRight: "5px" }}>
									{logos(ele.statName, orgDetail) ? logos(ele.statName, orgDetail) : <div className="genericStats-tab-point" style={{fontSize : "40px"}}>{ele.statValue}</div>}
								</div>
								<div style={{ display : "flex", alignItems: "center", }}>
									<div>
										{logos(ele.statName, orgDetail) != null && <div className="genericStats-tab-point">{ele.statValue}</div>}
										<div className="genericStats-tab-title">{ele.statName}</div>
									</div>
								</div>
							</div>
						);
					})}
			</div>
		</>
	);
}

export function GenericstatsV2({ statsFor, fetchStats, plantId}) {
	const [statData, setStatData] = useState([]);
	const { data: DeviceStatsData = {}, refetch: DeviceStatsRefetch } = ["devices", "Tag"].includes(statsFor)
		? useGetDeviceStatsQuery({ statsFor: statsFor, ...(plantId && { plantIds: plantId })}, { refetchOnMountOrArgChange: true })
		: {};
	const { data: UsersStatsData = {}, refetch: UsersRefetech } = ["users", "company", "roles"].includes(statsFor)
		? useGetUsersStatsQuery({ statsFor: statsFor}, { refetchOnMountOrArgChange: true })
		: {};
	const { data: VMSStatsData = {}, refetch: VMSStatsRefetch } = ["product", "productCategories", "supplier", "workflow", "checkpoint", "checkpointType"].includes(statsFor)
		? useGetVMSStatsQuery({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) }, { refetchOnMountOrArgChange: true })
		: {};
	const { data: DeviceStats } = DeviceStatsData;
	const { data: UsersStats } = UsersStatsData;
	const { data: VMSStats } = VMSStatsData;

	useEffect(() => {
		if (DeviceStats) {
			const UpdatedStats = Object.keys(DeviceStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof DeviceStats[key] !== "object" ? DeviceStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
		if (UsersStats) {
			const UpdatedStats = Object.keys(UsersStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof UsersStats[key] !== "object" ? UsersStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
		if (VMSStats) {
			const UpdatedStats = Object.keys(VMSStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof VMSStats[key] !== "object" ? VMSStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
	}, [DeviceStats, UsersStats, VMSStats]);

	useEffect(() => {
		if (DeviceStats) {
			DeviceStatsRefetch({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
		if (UsersStats) {
			UsersRefetech({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
		if (VMSStats) {
			VMSStatsRefetch({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
	}, [fetchStats]);

	const fetchLogo = (statName) => {
		switch (statName) {
			case "Total Vehicle Request":
				return TotalTruckRequest();
			case "Total Today Vehicle In":
				return TotalTruckIn();
			case "Total Today Vehicle Out":
				return TotalTruckOut();
			case "Total Devices":
				return <DeviceIcon style={{ fontSize: "3.5em" }} />;
			case "Total Tags":
				return <TagIcon style={{ fontSize: "3.2em" }} />;
			case "Total Allocated Tags":
				return AllocatedTag();
			case "Total Users":
				return <UsersIcon style={{ fontSize: "3.3em" }} />;
			case "Total Roles":
				return <RoleIcon style={{ fontSize: "3.3em" }} />;
			case "Total Product Categories":
				return <ProductCategoriesIcon style={{ fontSize: "3.2em" }} />;
			case "Total Products":
				return <ProductIcon style={{ fontSize: "3.3em" }} />;
			case "Total Suppliers":
				return <SupplierIcon style={{ fontSize: "3.5em" }} />;
			case "Total Companies":
				return <CompanyIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoints":
				return <ReportIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoint Types":
				return <CheckpointTypeIcon style={{ fontSize: "3.3em" }} />;
			case "Total Workflows":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Camera" :
				return <CameraAltIcon style={{ fontSize: "3.3em" }} />;
			case "Led" :
				return <BillBoardIcon style={{ fontSize: "3.3em" }} />;
			case "Rfid Reader" :
				return <RFIDIcon style={{ fontSize: "3.3em" }} />;
			case "Speaker" :
				return <SpeakerIcon style={{ fontSize: "3.3em" }} />;
			case "Workstation":
				return <WorkStation style={{fontSize: "1.3rem"}}/>;
			default:
				null;
		}
	};
	return (
		<>
			<div className="genericStats-containter">
				{statData.length > 0 &&
					statData.map((ele, index) => (
						<div className="genericStats-tab" key={ele.statName} onClick={(ele) => (onhandleFilter ? onhandleFilter(ele) : "")}>
							<div style={{ color: "#48494a", marginRight: "5px" }}>{fetchLogo(ele.statName)}</div>
							<div>
								<div className="genericStats-tab-point">{ele.statValue}</div>
								<div className="genericStats-tab-title">{ele.statName}</div>
							</div>
						</div>
					))}
			</div>
		</>
	);
}

export function ConsolidatedStats({ orgId, deviceOptions, vmsOptions, usersOptions, type }) {
	const [statData, setStatData] = useState([]);
	const { data: DeviceStatsData = {}, refetch: DeviceStatsRefetch } = useGetDeviceStatsQuery({ statsFor: deviceOptions, orgId }, { refetchOnMountOrArgChange: true });
	const { data: UsersStatsData = {}, refetch: UsersRefetech } = useGetUsersStatsQuery({ statsFor: usersOptions, orgId }, { refetchOnMountOrArgChange: true });
	const { data: VMSStatsData = {}, refetch: VMSStatsRefetch } = useGetVMSStatsQuery({ statsFor: vmsOptions, orgId }, { refetchOnMountOrArgChange: true });

	const { data: DeviceStats } = DeviceStatsData;
	const { data: UsersStats } = UsersStatsData;
	const { data: VMSStats } = VMSStatsData;

	useEffect(() => {
		DeviceStatsRefetch({ statsFor: deviceOptions, orgId });
		UsersRefetech({ statsFor: usersOptions, orgId });
		VMSStatsRefetch({ statsFor: vmsOptions, orgId });
	}, [orgId]);

	useEffect(() => {
		let UpdatedStats = [];
		if (DeviceStats) {
			const DeviceProcessedStats = Object.keys(DeviceStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof DeviceStats[key] !== "object" ? DeviceStats[key] : 0,
			}));
			UpdatedStats.push(...DeviceProcessedStats);
		}
		if (UsersStats) {
			const UserPorcessedStats = Object.keys(UsersStats).reduce(
				(acc, key) => (orgId && key === "TotalCompanies" ? acc : [...acc, { statName: capitalizeWords(key), statValue: typeof UsersStats[key] !== "object" ? UsersStats[key] : 0 }]),
				[]
			);
			UpdatedStats.push(...UserPorcessedStats);
		}
		if (VMSStats) {
			let VMSPorcessedStats = Object.keys(VMSStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof VMSStats[key] !== "object" ? VMSStats[key] : 0,
			}));
			UpdatedStats.push(...VMSPorcessedStats);
		}
		setStatData(UpdatedStats);
	}, [DeviceStats, UsersStats, VMSStats]);

	const fetchLogo = (statName) => {
		switch (statName) {
			case "Total Vehicle Request":
				return TotalTruckRequest();
			case "Total Today Vehicle In":
				return TotalTruckIn();
			case "Total Today Vehicle Out":
				return TotalTruckOut();
			case "Total Devices":
				return <DeviceIcon style={{ fontSize: "3.5em" }} />;
			case "Total Tags":
				return <TagIcon style={{ fontSize: "3.2em" }} />;
			case "Total Allocated Tags":
				return AllocatedTag();
			case "Total Users":
				return <UsersIcon style={{ fontSize: "3.3em" }} />;
			case "Total Roles":
				return <RoleIcon style={{ fontSize: "3.3em" }} />;
			case "Total Product Categories":
				return <ProductCategoriesIcon style={{ fontSize: "3.2em" }} />;
			case "Total Products":
				return <ProductIcon style={{ fontSize: "3.3em" }} />;
			case "Total Suppliers":
				return <SupplierIcon style={{ fontSize: "3.5em" }} />;
			case "Total Companies":
				return <CompanyIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoints":
				return <ReportIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoint Types":
				return <CheckpointTypeIcon style={{ fontSize: "3.3em" }} />;
			case "Total Workflows":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Completed Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Terminated Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Ongoing Trips":
				return <TripOngoing style={{fontSize:"8.3em"}}/>
			case "Total Cancelled Trips":
				return <CancelledTrip style={{fontSize:'3em'}}/>
			default:
				null;
		}
	};

	let stats;
	if (!type) {
		stats = (
			<>
				<div className="genericStats-containter">
					{statData.length > 0 &&
						statData.map((ele, index) => (
							<div className="genericStats-tab tab-element" key={ele.statName}>
								<div style={{ color: "#48494a", marginRight: "5px" }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
				</div>
			</>
		);
	} else {
		stats = (
			<div className="scroller" data-animated="false">
				<div className="genericStats-containter scroller-inner">
					{statData.length > 0 &&
						statData.map((ele, index) => (
							<div className="genericStats-tab scroller-element" key={ele.statName}>
								<div style={{ color: "#48494a", marginRight: "5px" }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
					{type === "infinite-scroll" &&
						statData.length > 0 &&
						statData.map((ele, index) => (
							<div aria-hidden={true} className="genericStats-tab scroller-element" key={ele.statName}>
								<div style={{ color: "#48494a", marginRight: "5px" }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
				</div>
			</div>
		);
	}
	return stats;
}

const logos = (statName, orgDetail) => {
	return statName === "Total Request"
		? TotalTruckRequest(orgDetail?.statIcon?.total)
		: statName === "Total Today In"
		? TotalTruckIn(orgDetail?.statIcon?.todayIn)
		: statName === "Total Today Out"
		? TotalTruckOut(orgDetail?.statIcon?.todayOut)
		: statName == "Total Currently In"
		? TotalCurrentIn(orgDetail?.statIcon?.currentIn)
		: null
}

const capitalizeWords = (str) => {
	return str
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ")
		.split(/(?=[A-Z])/)
		.join(" ");
};

const TotalTruckRequest = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M15 7h-2v7h-2V7H9v7H7V7H5v7H3V6h12zm3 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5z"
			/>
		</svg>
	);
};

const TotalTruckIn = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4zM3 6v9h.76c.55-.61 1.35-1 2.24-1s1.69.39 2.24 1H15V6zm2 4.5L6.5 9L8 10.5L11.5 7L13 8.5l-5 5z"
			/>
		</svg>
	);
};

const TotalTruckOut = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M18 4h-5v9H1v4h2c0 .83.3 1.53.89 2.13c.61.59 1.3.87 2.11.87s1.5-.28 2.11-.87c.59-.6.89-1.3.89-2.13h5.5c0 .83.28 1.53.88 2.13c.59.59 1.29.87 2.12.87c.8 0 1.5-.28 2.09-.87c.6-.6.91-1.3.91-2.13H23v-7zM7.08 18.07c-.28.3-.64.43-1.08.43s-.8-.13-1.08-.43s-.42-.65-.42-1.07c0-.39.14-.74.42-1.04s.64-.46 1.08-.46s.8.16 1.08.46s.42.65.42 1.04c0 .42-.14.77-.42 1.07m11.46 0c-.3.3-.65.43-1.04.43c-.42 0-.77-.13-1.07-.43S16 17.42 16 17c0-.39.13-.74.43-1.04s.65-.46 1.07-.46c.39 0 .74.16 1.04.46s.46.65.46 1.04c0 .42-.16.77-.46 1.07M15 10V6h2.06l3.33 4z"
			/>
		</svg>
	);
};

const AllocatedTag = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="3.2em" height="3.2em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7m3.13 7.27l-3.87 3.9l-1.35-1.37L2 18.22L4.75 21l5.28-5.32z"
			/>
		</svg>
	);
};

const TotalCurrentIn = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg width="4em" height="4em" viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" xmlSpace="preserve">
			<g>
				<g>
					<path
						fill="currentColor"
						d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078    C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541    c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z     M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812    c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812    h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16    c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z     M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539    c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751    c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907    c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29    l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697    c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347    C565.257,281.569,563.532,285.839,560.084,285.839z"
					/>
				</g>
			</g>
		</svg>
	);
};
export const TripOngoing = ({ size = "2.6em" }) => {
	return(
		<svg width={size} height={size} viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" xmlSpace="preserve">
			<g>
				<g>
					<path
						fill="currentColor"
						d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078    C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541    c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z     M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812    c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812    h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16    c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z     M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539    c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751    c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907    c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29    l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697    c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347    C565.257,281.569,563.532,285.839,560.084,285.839z"
					/>
				</g>
			</g>
		</svg>
	)
};
export const CancelledTrip=({size="2.8em"})=>{
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width={size} height={size}>
			<g id="Layer_23" data-name="Layer 23">
				<path fill="currentColor" d="M60.92,40.79,55.25,27a1,1,0,0,0-.92-.62H43.82a1,1,0,0,0-1,1V45.6H40.43V19.17a1,1,0,0,0-1-1h-5A12.73,12.73,0,0,0,9,18.17H4a1,1,0,0,0-1,1V51a1,1,0,0,0,1,1H6.68a5.44,5.44,0,0,0,10.7,0h2.39a5.44,5.44,0,0,0,10.7,0H46.65a5.44,5.44,0,0,0,10.7,0H60a1,1,0,0,0,1-1V41.17A1,1,0,0,0,60.92,40.79ZM21.71,8.42A10.75,10.75,0,1,1,11,19.17,10.76,10.76,0,0,1,21.71,8.42ZM6.68,50H5V47.6H7.76A5.48,5.48,0,0,0,6.68,50ZM12,54.4a3.44,3.44,0,0,1-.77-6.8H12.8A3.44,3.44,0,0,1,12,54.4ZM19.77,50H17.38a5.47,5.47,0,0,0-1.07-2.36h4.53A5.47,5.47,0,0,0,19.77,50Zm5.35,4.44a3.44,3.44,0,0,1-.77-6.8h1.54a3.44,3.44,0,0,1-.77,6.8ZM42.82,50H30.47a5.48,5.48,0,0,0-1.08-2.36H42.82ZM52,54.4A3.45,3.45,0,1,1,55.45,51,3.45,3.45,0,0,1,52,54.4ZM59,50H57.35a5.44,5.44,0,0,0-10.7,0H44.82V28.38h4.64V41.17a1,1,0,0,0,1,1H59Z"/>
				<path d="M16.29,24.6a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29l4-4,4,4a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-4-4,4-4a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0l-4,4-4-4a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4,4-4,4A1,1,0,0,0,16.29,24.6Z"/>
			</g>
		</svg>
	)
}

export const TripCreated = ({ size = "2.6em" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M15 7h-2v7h-2V7H9v7H7V7H5v7H3V6h12zm3 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5z"
			/>
		</svg>
	);
};

export const TripTerminated = ({ size = "2.6em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 126 69" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.007 52H0V35H23H34H45.5H57H69H80V0.5H92H108.5L125.5 22V52H114.993C114.728 61.4338 106.998 69 97.5 69C88.0022 69 80.2717 61.4338 80.007 52H45.993C45.7283 61.4338 37.9978 69 28.5 69C19.0022 69 11.2717 61.4338 11.007 52ZM116.5 23L106.5 9H92V23H116.5ZM38 51.5C38 56.7467 33.7467 61 28.5 61C23.2533 61 19 56.7467 19 51.5C19 46.2533 23.2533 42 28.5 42C33.7467 42 38 46.2533 38 51.5ZM97.5 61C102.747 61 107 56.7467 107 51.5C107 46.2533 102.747 42 97.5 42C92.2533 42 88 46.2533 88 51.5C88 56.7467 92.2533 61 97.5 61Z"
				fill="#3E3E3E"
			/>
		</svg>
	);
};

export const TripCompleted = ({ size = "2.6em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 126 91" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.007 74H0V0H92V22.5H108.5L125.5 44V74H114.993C114.728 83.4338 106.998 91 97.5 91C88.0022 91 80.2717 83.4338 80.007 74H45.993C45.7283 83.4338 37.9978 91 28.5 91C19.0022 91 11.2717 83.4338 11.007 74ZM80 57V10.5H11.5V57H23H34H45.5H57H69H80ZM116.5 45L106.5 31H92V45H116.5ZM38 73.5C38 78.7467 33.7467 83 28.5 83C23.2533 83 19 78.7467 19 73.5C19 68.2533 23.2533 64 28.5 64C33.7467 64 38 68.2533 38 73.5ZM97.5 83C102.747 83 107 78.7467 107 73.5C107 68.2533 102.747 64 97.5 64C92.2533 64 88 68.2533 88 73.5C88 78.7467 92.2533 83 97.5 83Z"
				fill="#3E3E3E"
			/>
			<path d="M28 33.5L40.5 45.5L66 21" stroke="#3E3E3E" strokeWidth="10" />
		</svg>
	);
};

export const WorkStation = ({ size = "2.9em" }) => {
	return(
		<svg width={size} height={size} viewBox="0 0 288 448" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M160 320H128C123.757 320 119.687 321.686 116.686 324.686C113.686 327.687 112 331.757 112 336C112 340.243 113.686 344.313 116.686 347.314C119.687 350.314 123.757 352 128 352H160C164.243 352 168.313 350.314 171.314 347.314C174.314 344.313 176 340.243 176 336C176 331.757 174.314 327.687 171.314 324.686C168.313 321.686 164.243 320 160 320Z" fill="#3E3E3E"/>
			<path d="M240 0H48C35.2739 0.0138911 23.073 5.07548 14.0742 14.0742C5.07548 23.073 0.0138911 35.2739 0 48V368C0.0304731 377.894 3.12277 387.536 8.85235 395.602C14.5819 403.669 22.6679 409.764 32 413.051V432C32 436.243 33.6857 440.313 36.6863 443.314C39.6869 446.314 43.7565 448 48 448C52.2435 448 56.3131 446.314 59.3137 443.314C62.3143 440.313 64 436.243 64 432V416H224V432C224 436.243 225.686 440.313 228.686 443.314C231.687 446.314 235.757 448 240 448C244.243 448 248.313 446.314 251.314 443.314C254.314 440.313 256 436.243 256 432V413.052C265.332 409.764 273.418 403.669 279.148 395.603C284.877 387.536 287.97 377.894 288 368V48C287.986 35.2739 282.925 23.073 273.926 14.0742C264.927 5.07548 252.726 0.0138911 240 0ZM256 368C255.994 372.242 254.307 376.308 251.308 379.308C248.308 382.307 244.242 383.995 240 384H48C43.7582 383.995 39.6918 382.307 36.6924 379.308C33.693 376.308 32.0055 372.242 32 368V48C32.0055 43.7582 33.693 39.6918 36.6924 36.6924C39.6918 33.693 43.7582 32.0055 48 32H240C244.242 32.0055 248.308 33.693 251.308 36.6924C254.307 39.6918 255.994 43.7582 256 48V368Z" fill="#3E3E3E"/>
			<path d="M208 64H80C75.7565 64 71.6869 65.6857 68.6863 68.6863C65.6857 71.6869 64 75.7565 64 80C64 84.2435 65.6857 88.3131 68.6863 91.3137C71.6869 94.3143 75.7565 96 80 96H208C212.243 96 216.313 94.3143 219.314 91.3137C222.314 88.3131 224 84.2435 224 80C224 75.7565 222.314 71.6869 219.314 68.6863C216.313 65.6857 212.243 64 208 64Z" fill="#3E3E3E"/>
			<path d="M208 128H80C75.7565 128 71.6869 129.686 68.6863 132.686C65.6857 135.687 64 139.757 64 144C64 148.243 65.6857 152.313 68.6863 155.314C71.6869 158.314 75.7565 160 80 160H208C212.243 160 216.313 158.314 219.314 155.314C222.314 152.313 224 148.243 224 144C224 139.757 222.314 135.687 219.314 132.686C216.313 129.686 212.243 128 208 128Z" fill="#3E3E3E"/>
		</svg>
	)

}